/**
 * Administration Feature Constants
 * Centralized constants for colors, styles, and configurations
 */

// Role color mappings for tags
export const ROLE_COLORS = {
  admin: "red",
  operator: "blue",
  log_manager: "green",
  default: "gray",
};

// Robot status color mappings
export const STATUS_COLORS = {
  online: "success",
  offline: "default",
  error: "error",
};

// Available colors for organization tags
export const ORGANIZATION_COLORS = [
  "blue",
  "green",
  "red",
  "orange",
  "purple",
  "cyan",
  "magenta",
];

// Common button styles
export const BUTTON_STYLES = {
  add: {
    whiteSpace: "nowrap",
    padding: "0 12px",
    maxWidth: "250px",
    width: "100%",
    textOverflow: "ellipsis",
    display: "block",
    alignItems: "center",
    justifyContent: "center",
  },
};

// Default pagination settings
export const PAGINATION_DEFAULTS = {
  page: 1,
  perPage: 10,
  pageSizeOptions: ["5", "10", "20", "50", "100"],
};

// Robot pagination defaults
export const ROBOT_PAGINATION_DEFAULTS = {
  page: 1,
  perPage: 5,
  pageSizeOptions: ["5", "10", "20", "50"],
};

// User table pagination defaults
export const USER_TABLE_PAGINATION_DEFAULTS = {
  page: 1,
  perPage: 7,
  pageSizeOptions: ["5", "7", "10", "20", "50"],
};

// Available role types
export const ROLE_TYPES = {
  ADMIN: "admin",
  OPERATOR: "operator",
  LOG_MANAGER: "log_manager",
};

// Translation keys for roles
export const ROLE_TRANSLATION_KEYS = {
  admin: "admin",
  operator: "operator",
  log_manager: "logManager",
};

/**
 * Get color for a role
 * @param {string} role - Role name
 * @returns {string} Color name
 */
export const getRoleColor = (role) => {
  return ROLE_COLORS[role] || ROLE_COLORS.default;
};

/**
 * Get translation key for a role
 * @param {string} role - Role name
 * @returns {string} Translation key
 */
export const getRoleTranslationKey = (role) => {
  return ROLE_TRANSLATION_KEYS[role] || role;
};

/**
 * Color map for organizations (to maintain consistent colors)
 */
export class OrganizationColorManager {
  constructor() {
    this.colorMap = new Map();
    this.availableColors = [...ORGANIZATION_COLORS];
  }

  getColor(organizationId) {
    if (!this.colorMap.has(organizationId)) {
      const colorIndex = this.colorMap.size % this.availableColors.length;
      this.colorMap.set(organizationId, this.availableColors[colorIndex]);
    }
    return this.colorMap.get(organizationId);
  }

  reset() {
    this.colorMap.clear();
  }
}
